import {Product} from "./product";

export class ProductSize {

    id?: string;
    name: string = '';
    product?: Product[];
    companyId: string = '';


    constructor(raw?: any) {
        if (raw) {
            if (raw.id || raw.id !== '') this.id = raw.id
            this.name = raw.name;
            this.product = raw.product;
            this.companyId = raw.companyId;
        }
    }
}
